import SelectedHotelChainFilter from './containers/hotelChainFilter/SelectedHotelChainFilter';
import SelectedPropertyTypeFilter from './containers/propertyTypeFilter/SelectedPropertyTypeFilter';
import SelectedHotelFacilityFilter from './containers/hotelFacilityFilter/SelectedHotelFacilityFilter';
import SelectedStarRatingFilter from './containers/starRatingFilter/SelectedStarRatingFilter';
import SelectedGuestRatingFilter from './containers/guestRatingFilter/SelectedGuestRatingFilter';
import SelectedPriceFilter from './containers/priceFilter/SelectedPriceFilter';
import SelectedKeywordFilter from './containers/keywordFilter/SelectedKeywordFilter';
import { SelectedFavoriteFoldersFilter } from '../selectedFavoriteFoldersFilter/SelectedFavoriteFoldersFilter';

interface Props {
    openFilters: () => void;
    className?: string;
}

export const SelectedFilters = ({ openFilters, className = '' }: Props) => (
    <ul className={`selected-filters u-mb0 ${className}`} data-testid="selected-filters">
        <SelectedFavoriteFoldersFilter openFilters={openFilters} />
        <SelectedPropertyTypeFilter openFilters={openFilters} />
        <SelectedStarRatingFilter openFilters={openFilters} />
        <SelectedGuestRatingFilter openFilters={openFilters} />
        <SelectedHotelFacilityFilter openFilters={openFilters} />
        <SelectedPriceFilter openFilters={openFilters} />
        <SelectedKeywordFilter openFilters={openFilters} />
        <SelectedHotelChainFilter openFilters={openFilters} />
    </ul>
);
